/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Anchor } from 'grommet';

import { BlendBridge } from 'blb-types/blendBridge';
import { BaseRedirectTask } from 'blb-components/AuthenticatedApp/DashboardPage/Task/BaseRedirectTask';
import { EditRecipientsModal } from './EditRecipientsModal';

export namespace TaggingTask {
  export interface Props extends BlendBridge.API.TaggingTask {
    onSuccess: () => Promise<any>;
    taskId: string;
  }
}

export const TaggingTask: React.FC<TaggingTask.Props> = ({
  taskHeader,
  disabledReason,
  isDisabled,
  onSuccess,
  taskId,
  buttonLabel = 'Open',
}) => {
  const [showEditRecipientsModal, setShowEditRecipientsModal] = React.useState<boolean>(false);
  const [envelopeProviderId, setEnvelopeProviderId] = React.useState<string>('');
  const [providerUrl, setProviderUrl] = React.useState<string>('');
  const [isFullEnvelopeTagging, setIsFullEnvelopeTagging] = React.useState<boolean>(false);

  const decideActionFunc = (response: BlendBridge.API.RedirectTaskFetchUrlResponse, isTagAllDocs?: boolean) => {
    const { envelopeProviderId: envelopeId, url } = response as BlendBridge.API.TaggingTaskFetchUrlResponse;
    setEnvelopeProviderId(envelopeId);

    const urlParams = new URLSearchParams(url);
    setProviderUrl(urlParams.get('target') || '');

    isTagAllDocs && setIsFullEnvelopeTagging(true);
  };

  const editRecipientsModal = (
    <EditRecipientsModal
      envelopeProviderId={envelopeProviderId}
      handleClose={() => {
        setShowEditRecipientsModal(false);
        setIsFullEnvelopeTagging(false);
      }}
      isOpen={showEditRecipientsModal}
      providerUrl={providerUrl}
      taskId={taskId}
    />
  );

  const editRecipientsLinkButton = (
    <Anchor
      id={`it-task-${taskId}-EditRecipientsLinkButton`}
      label="Edit recipients"
      margin="small"
      onClick={() => setShowEditRecipientsModal(true)}
      size="medium"
      weight="normal"
    />
  );

  return (
    <BaseRedirectTask
      buttonLabel={buttonLabel}
      disabledReason={disabledReason}
      iframeComponents={{
        children: showEditRecipientsModal ? editRecipientsModal : undefined,
        subtitle: isFullEnvelopeTagging ? editRecipientsLinkButton : undefined,
      }}
      isDisabled={isDisabled}
      key={taskHeader}
      onFetchAndDecide={decideActionFunc}
      onModalClose={() => {
        setIsFullEnvelopeTagging(false);
      }}
      onSuccess={onSuccess}
      taskHeader={taskHeader}
      taskId={taskId}
      type={BlendBridge.TaskTypes.TAGGING}
      urlOpenMethod={BlendBridge.API.FetchUrlOpenMethod.FETCH_AND_DECIDE}
    />
  );
};
